import { apiIdentityUrl } from "../../../lib/tenantOrigin";
import { Box } from "../../Box";
import { Text } from "../../Text";
import { CopyableField } from "./CopyableField";
import { SubLabel } from "./shared";
import { spAcsUrl, spEntityId, spMetadataUrl } from "./urls";

export function SpDetails({
  providerId,
  isNew,
}: {
  providerId: string;
  isNew?: boolean;
}) {
  return (
    <>
      <SubLabel>For your identity provider</SubLabel>
      {isNew ? (
        <Box horizontal={8}>
          <Text variant="text-small" color="var(--text-secondary)">
            The SP metadata URL, entity ID, and ACS URL to configure your IdP
            will appear here once you add the provider.
          </Text>
        </Box>
      ) : (
        <>
          <CopyableField
            label="SP metadata URL"
            hint="Import this into your IdP to configure the service provider side"
            value={spMetadataUrl(apiIdentityUrl(), providerId)}
          />
          <CopyableField
            label="SP entity ID"
            hint="Your IdP calls this the audience or service provider identifier"
            value={spEntityId(apiIdentityUrl())}
          />
          <CopyableField
            label="ACS URL"
            hint="Add this to your IdP as the assertion consumer service (ACS) URL"
            value={spAcsUrl(apiIdentityUrl(), providerId)}
          />
        </>
      )}
    </>
  );
}
